// frontend/src/router/index.js

// Import changed for LCA routes
import { createRouter, createWebHistory } from 'vue-router';
import MainView from '../views/MainView.vue';
import DynamicComponentView from '../views/DynamicComponentView.vue';
import ToolDescriptionPageView from '../views/ToolDescriptionPageView.vue';
import StepperView from '../views/StepperView.vue';
import HomeView from '../views/HomeView.vue';
import SolutionDetailsView from '../views/SolutionDetailsView.vue';
import LogInMaskView from '../views/LogInMaskView.vue';
import RegisterMaskView from '../views/RegisterMaskView.vue';
import PasswordResetView from '../views/PasswordResetView.vue'; // UPDATED IMPORT
import AccountSettingsView from '../views/AccountSettingsView.vue';
import { useAuthStore } from '../stores/auth';
import LCAStepperView from '../views/LCAStepperView.vue';
import CompanyData from '../components/Stepper/CompanyData.vue';
import FoodSurplusData from '../components/Stepper/FoodSurplusData.vue';
import Solutions from '../components/Stepper/Solutions.vue';

// Import LCA step components with new names
import {
  LifecycleStageSelector,
  SolutionSelector,
  ProviderSelector,
  TransportEmissionsCalculator,
  LCAReportViewer,
  stepConfig
} from '../components/LCA/Stepper';

import SolutionDetails from '../components/solution_details/SolutionDetails.vue';
import PrivacyPolicyView from '../views/PrivacyPolicyView.vue';
import ImpressumView from '../views/ImpressumView.vue';

const routes = [
  {
    path: '/main',
    name: 'main',
    component: MainView,
    meta: { requiresAuth: true },
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: PrivacyPolicyView,
  },
  {
    path: '/impressum',
    name: 'impressum',
    component: ImpressumView,
  },
  {
    path: '/component/:componentName',
    name: 'dynamic-component',
    component: DynamicComponentView,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/tool-description',
    name: 'tool-description',
    component: ToolDescriptionPageView,
  },
  {
    path: '/tool',
    name: 'tool',
    component: StepperView,
    meta: { requiresAuth: true },
  },
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/stepper',
    name: 'stepper',
    component: StepperView,
    meta: { requiresAuth: true },
    redirect: '/stepper/company-data',
    children: [
      {
        path: 'company-data',
        name: 'company-data',
        component: CompanyData,
      },
      {
        path: 'food-surplus',
        name: 'food-surplus',
        component: FoodSurplusData,
      },
      {
        path: 'solutions',
        name: 'solutions',
        component: Solutions,
      },
    ],
  },
  {
    path: '/solution/:id',
    name: 'solution-details',
    component: SolutionDetails,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/lca-stepper',
    name: 'LCAStepperView',
    component: LCAStepperView,
    meta: { requiresAuth: true },
    redirect: () => {
      // Dynamically create the first route based on active steps
      const activeSteps = stepConfig.getActiveSteps();
      if (activeSteps.length > 0) {
        return `/lca-stepper/${activeSteps[0].path}`;
      }
      return '/lca-stepper/solution'; // Default fallback
    },
    children: [
      {
        path: 'lifecycle-stage',
        name: 'lca-lifecycle-stage',
        component: LifecycleStageSelector,
      },
      {
        path: 'solution',
        name: 'lca-solution',
        component: SolutionSelector,
      },
      {
        path: 'provider',
        name: 'lca-provider',
        component: ProviderSelector,
      },
      {
        path: 'transport',
        name: 'lca-transport',
        component: TransportEmissionsCalculator,
      },
      {
        path: 'report',
        name: 'lca-report',
        component: LCAReportViewer,
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: LogInMaskView,
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterMaskView,
  },
  // Password Reset Route - Updated to use new structure
  {
    path: '/reset-password',
    name: 'reset-password',
    component: PasswordResetView,
    props: route => ({ token: route.query.token })
  },
  // Account Settings Route
  {
    path: '/account-settings',
    name: 'account-settings',
    component: AccountSettingsView,
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      };
    } else {
      return { top: 0 };
    }
  }
});

// Enhanced Auth Guard
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();

  // Check if route requires authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // If not logged in, redirect to login page with return URL
    if (!authStore.isLoggedIn) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    } else {
      // User is logged in, proceed
      next();
    }
  } else {
    // Route doesn't require auth, always allow
    next();
  }
});

router.afterEach((to, from) => {
  if (typeof gtag !== 'undefined') {
    gtag('config', 'G-ZYD6QP1GQZ', {
      page_path: to.fullPath,
    });
  }
});

export default router;